<template>
	<div class="analyzer-link--wrap">
		<template v-if="(view_type === 'list')">
			<router-link :to="{ name: 'ArmView_Card', params: { vpId, armId, recordId }, query: { linkAnalyzed: true } }">
				{{ armName }} ({{ armId }}), {{ vpName }} ({{ vpId }}), ID {{ recordId }}
			</router-link>
		</template>
		<template v-else>{{ value }}</template>
	</div>
</template>

<script>
  export default {
    name: "spc_entity_link_analyzer",
		props: {
			view_type: {
				type: String
			},
			value: {
				default: ''
			},
			field_meta: {
				type: Object
			},
			record_data: {
				type: Object
			}
		},
		computed: {
			armId () {
				return this.record_data['arm_id'] || ''
			},
			armName () {
				return this.record_data['arm_name'] || ''
			},
			vpId () {
				return this.record_data['vp_id'] || ''
			},
			vpName () {
				return this.record_data['vp_name'] || ''
			},
			recordId () {
				return this.record_data['entity_id'] || ''
			},
			fieldCode () {
				return this.record_data['field_code'] || ''
			},
		}
  }
</script>

<style scoped>

</style>
